import { RootState } from "../store";
import { MaintenanceRequestWithRelations } from "@/types/maintenance";

export const selectAllMaintenanceRequests = (state: RootState) =>
  state.maintenance.maintenanceRequests as MaintenanceRequestWithRelations[];

export const selectMaintenanceRequestsLoading = (state: RootState) =>
  state.maintenance.loading;

export const selectMaintenanceRequestsError = (state: RootState) =>
  state.maintenance.error;
